import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BUYING_LABEL, SELLER_PATH, SELLER_LABEL } from 'data/global';
import AuthContext from 'providers/Auth/Auth.context';

import './PortfolioHeading.styles.scss';

type PortfolioHeadingProps = {
  className?: string;
};

const PortfolioHeading: React.FC<PortfolioHeadingProps> = (props) => {
  const { className } = props;

  const { latestActivityMetricsLocation } = useContext(AuthContext);

  const classes = classNames('portfolio-heading', className);

  const { t } = useTranslation();

  const { pathname } = useLocation();

  const isSeller = useMemo(() => pathname.includes(SELLER_PATH), [pathname]);

  const stepName = useMemo(() => {
    if (isSeller) return SELLER_LABEL;

    return BUYING_LABEL;
  }, [isSeller]);

  return (
    <nav className={classes}>
      <h2>{t(stepName)}</h2>

      {latestActivityMetricsLocation && (
        <Link to={latestActivityMetricsLocation}>
          {t('goBackToActivityMetrics')}
        </Link>
      )}
    </nav>
  );
};

export default PortfolioHeading;
